import { getData } from '@core/utils/http/general'

const getNivelAcademicoCatalogo = async () => {
  try {
    const { status: statusReq, statusText, data } = await getData({ action: 37 })
    if (statusReq !== 200) throw statusText

    const { status, message, data: niveles } = data

    if (status !== 200) throw message

    return niveles
  } catch (error) {
    return error
    // console.error(error)
    // throw error
  }
}

export default getNivelAcademicoCatalogo
